<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">Asset QR Entry</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>
<div>
    <div class="p-2">
        <form class="example-form">
            <form>
                <div>
                    <div class="pt-3">
                        <div class="col-md-12">
                            <span class="image_format">Fusion Building Code</span>
                        </div>
                    </div>
                    <div class="pt-1">
                        <div class="col-md-12">
                            <div class="input-group">
                                <input type="text" #searchInput class="form-control misinput_control" [(ngModel)]="searchorg">
                                <div>
                                    <button class="btn drop_iconsearch" type="submit" (click)="search(searchorg)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pt-3">
                        <div class="col-md-12">
                            <span class="image_format">Building Name</span>
                        </div>
                    </div>
                    <div class="pt-1">
                        <div class="col-md-12">
                            <input class="form-control" type="text" placeholder="{{buildingName}}">
                        </div>
                    </div>
                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Major Category</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Minor Category</span>
                        </div>
                    </div>
                    <div class="d-flex pt-1 gap-1">
                        <div class="col-md-6">
                            <select name="" id="" class="drpdwn" (change)="onSelectedMajor($event)">
                                <option value="">Select Major Category</option>
                                <option *ngFor="let data of majorcategorydetails" [value]="data.catMajorId">
                                    {{data.categoryName}}</option>
                            </select>
                        </div>

                        <div class="col-md-6">
                            <select name="" id="" class="drpdwn" (change)="onSelectedMinor($event)">
                                <option value="">Select Minor Category</option>
                                <option *ngFor="let data of minorcategorydetails" [value]="data.catMinorId">
                                    {{data?.categoryName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Vehicle Number</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Organization</span>
                        </div>
                    </div>
                    <div class="d-flex pt-1 gap-1">
                        <div class="col-md-6">
                            <input class="form-control" #vehicleInput type="text" [(ngModel)]="vehiclenumber">
                        </div>
                        <div class="col-md-6">
                            <select name="" id="" class="drpdwn" (change)="onSelectedOrganization($event)">
                                <option value="">Select Organization</option>
                                <option *ngFor="let data of organizationdetails" [value]="data.orgId">
                                    {{data.orgName}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
            <div class="col-lg-12 text-center pt-2">
                <button type="button" class="cctv_notebtn" (click)="onSubmit()">Submit</button>
            </div>
        </form>
    </div>
</div>

<!-- Loader -->
<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner> -->